import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UtilService, VwoService } from '../../shared/services';

@Component({
  selector: 'app-homepage-sip-banner',
  templateUrl: './homepage-sip-banner.component.html',
  styleUrls: ['./homepage-sip-banner.component.scss']
})
export class HomepageSipBannerComponent implements OnInit, OnDestroy {

  @Input() fundraiser;
  animation = false;
  interval;
  isMobile;

  constructor(
    public util: UtilService,
    public vwo: VwoService
  ) { }

  ngOnInit() {
    this.isMobile = this.util?.isMobile();
    this.interval = setInterval(() => {
      if (this.animation) {
        this.animation = false;
      } else {
        this.animation = true;
      }
    }, 1500)
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }

}
